'use strict';

import {BaseElement} from "../BaseElement";

export class Switch {
  constructor(parent) {
    this.switch = new BaseElement('label')
        .addClass('switch')
        .appendTo(parent)
        .DOMElement;
    this.checkbox = new BaseElement('input')
        .addClass('switch__checkbox')
        .setAttributes({
          'type': 'checkbox',
          'checked': false
        })
        .appendTo(this.switch)
        .DOMElement;
    this.slider = new BaseElement('span')
        .addClass('switch__slider')
        .appendTo(this.switch)
        .DOMElement;
  }

  set checked(value) {
    if (value === true || value === false)
      this.checkbox.checked = value;
  }

  set listener(value) {
    this.checkbox.addEventListener('change', value);
  }

  set change(value) {
    this.checkbox.addEventListener('change', value);
  }
}